import styled from "styled-components/macro"

const Paragraph = styled.p`
  &:not(:last-child) {
    margin-bottom: ${(p) => p.theme.baseLineHeight}em;
  }
`

export { Paragraph }
